export enum Layer {
	'Corner' = 'Corner',
	'Countertop' = 'Countertop',
	'Panel' = 'Panel',
	'UnderlyingPanel' = 'Underlying Panel',
	'Overlay' = 'Overlays',
	'FinishedEdge' = 'Finished Edges',
	'Label' = 'Labels',
	'LandingZone' = 'Landing Zones',
	'Dimension' = 'Dimensions',
	'Hint' = 'Hint'
}
